import * as constants from './wrike.constants';
import * as types from './wrike.types';

export const integrateWrike = (code: string, state: string) => ({
  type: constants.INTEGRATE_WRIKE,
  payload: { code, state },
});

export const fetchWrikeFolders = (params?: types.IWrikeFoldersParams) => ({
  type: constants.FETCH_WRIKE_FOLDERS,
  payload: params,
});

export const syncWrikeFolders = (payload: types.ISyncWrikeFoldersPayload) => ({
  type: constants.SYNC_WRIKE_FOLDERS,
  payload,
});

export const removeWrikeIntegration = () => ({
  type: constants.REMOVE_WRIKE_INTEGRATION,
});
